module.exports = __webpack_public_path__ + "static/media/content-dien-gio-1.d2fde981.jpg";